<ul class="c-sidebar-nav">

  <li class="c-sidebar-nav-item" *ngIf="usuario!.includes('DASHBOARD')">
    <a class="c-sidebar-nav-link" matRipple routerLink="home" routerLinkActive="c-active">
      <i class="c-sidebar-nav-icon"><mat-icon>home</mat-icon></i>
      <span class="c-sidebar-nav-text">Dashboard</span>
    </a>
  </li>

  <!-- Financeiro -->
  <li class="c-sidebar-nav-dropdown" [class.c-show]="menusAbertos['financeiro']"
    *ngIf="usuario!.includes('CONTA_PAGAR') || usuario!.includes('CONTA_RECEBER') || usuario!.includes('CONTA_CORRENTE')">
    <a class="c-sidebar-nav-dropdown-toggle" (click)="alternarMenu('financeiro')">
      <i class="c-sidebar-nav-icon"><mat-icon class="material-symbols-outlined">account_balance_wallet</mat-icon></i>
      <span class="c-sidebar-nav-text">Financeiro</span>
    </a>
    <ul class="c-sidebar-nav-dropdown-items">
      <li class="c-sidebar-nav-item" *ngIf="usuario!.includes('CONTA_PAGAR')">
        <a class="c-sidebar-nav-link" matRipple routerLink="contaPagar" routerLinkActive="c-active"
          [routerLinkActiveOptions]="menuSubset">
          <i class="c-sidebar-nav-icon"><mat-icon class="material-symbols-outlined">payments</mat-icon></i>
          <span class="c-sidebar-nav-text">Contas à Pagar</span>
        </a>
      </li>
      <li class="c-sidebar-nav-item" *ngIf="usuario!.includes('CONTA_RECEBER')">
        <a class="c-sidebar-nav-link" matRipple routerLink="contaReceber" routerLinkActive="c-active"
          [routerLinkActiveOptions]="menuSubset">
          <i class="c-sidebar-nav-icon"><mat-icon class="material-symbols-outlined">attach_money</mat-icon></i>
          <span class="c-sidebar-nav-text">Contas à Receber</span>
        </a>
      </li>
      <li class="c-sidebar-nav-item" *ngIf="usuario!.includes('CONTA_RECEBER')">
        <a class="c-sidebar-nav-link" matRipple routerLink="contaReceber/lote" routerLinkActive="c-active"
          [routerLinkActiveOptions]="menuSubset">
          <i class="c-sidebar-nav-icon"><mat-icon>receipt_long</mat-icon></i>
          <span class="c-sidebar-nav-text">Gerar Conta Receber em Lote</span>
        </a>
      </li>
      <li class="c-sidebar-nav-item" *ngIf="usuario!.includes('CONTA_CORRENTE') || usuario!.includes('CONTA_RECEBER')">
        <a class="c-sidebar-nav-link" matRipple routerLink="contaCorrente" routerLinkActive="c-active"
          [routerLinkActiveOptions]="menuSubset">
          <i class="c-sidebar-nav-icon"><mat-icon>account_balance</mat-icon></i>
          <span class="c-sidebar-nav-text">Contas Correntes</span>
        </a>
      </li>
    </ul>
  </li>

  <!-- Cadastros -->
  <li class="c-sidebar-nav-dropdown" [class.c-show]="menusAbertos['cadastros']"
    *ngIf="usuario!.includes('CLIENTE') || usuario!.includes('FORNECEDOR') || usuario!.includes('PLANO') || usuario!.includes('FUNCIONALIDADE') || usuario!.includes('SEGMENTO')">
    <a class="c-sidebar-nav-dropdown-toggle" (click)="alternarMenu('cadastros')">
      <i class="c-sidebar-nav-icon"><mat-icon>inventory_2</mat-icon></i>
      <span class="c-sidebar-nav-text">Cadastros</span>
    </a>
    <ul class="c-sidebar-nav-dropdown-items">
      <li class="c-sidebar-nav-item" *ngIf="usuario!.includes('CLIENTE')">
        <a class="c-sidebar-nav-link" matRipple routerLink="client" routerLinkActive="c-active"
          [routerLinkActiveOptions]="menuSubset">
          <i class="c-sidebar-nav-icon"><mat-icon>people_outline</mat-icon></i>
          <span class="c-sidebar-nav-text">Clientes</span>
        </a>
      </li>
      <li class="c-sidebar-nav-item" *ngIf="usuario!.includes('FORNECEDOR')">
        <a class="c-sidebar-nav-link" matRipple routerLink="fornecedor" routerLinkActive="c-active"
          [routerLinkActiveOptions]="menuSubset">
          <i class="c-sidebar-nav-icon"><mat-icon>store_front</mat-icon></i>
          <span class="c-sidebar-nav-text">Fornecedores</span>
        </a>
      </li>
      <li class="c-sidebar-nav-item" *ngIf="usuario!.includes('PLANO')">
        <a class="c-sidebar-nav-link" matRipple routerLink="plano" routerLinkActive="c-active"
          [routerLinkActiveOptions]="menuSubset">
          <i class="c-sidebar-nav-icon"><mat-icon>credit_card</mat-icon></i>
          <span class="c-sidebar-nav-text">Planos</span>
        </a>
      </li>
      <li class="c-sidebar-nav-item" *ngIf="usuario!.includes('FUNCIONALIDADE')">
        <a class="c-sidebar-nav-link" matRipple routerLink="funcionalidade" routerLinkActive="c-active"
          [routerLinkActiveOptions]="menuSubset">
          <i class="c-sidebar-nav-icon"><mat-icon>widgets</mat-icon></i>
          <span class="c-sidebar-nav-text">Funcionalidades</span>
        </a>
      </li>
      <li class="c-sidebar-nav-item" *ngIf="usuario!.includes('SEGMENTO')">
        <a class="c-sidebar-nav-link" matRipple routerLink="segmento" routerLinkActive="c-active"
          [routerLinkActiveOptions]="menuSubset">
          <i class="c-sidebar-nav-icon"><mat-icon>apps</mat-icon></i>
          <span class="c-sidebar-nav-text">Segmentos (Sistemas)</span>
        </a>
      </li>
    </ul>
  </li>

  <!-- Colaboradores / RH -->
  <li class="c-sidebar-nav-dropdown" [class.c-show]="menusAbertos['rh']"
    *ngIf="usuario!.includes('DEPARTAMENTO') || usuario!.includes('CARGO') || usuario!.includes('COLABORADOR')">
    <a class="c-sidebar-nav-dropdown-toggle" (click)="alternarMenu('rh')">
      <i class="c-sidebar-nav-icon"><mat-icon>groups</mat-icon></i>
      <span class="c-sidebar-nav-text">Colaboradores</span>
    </a>
    <ul class="c-sidebar-nav-dropdown-items">
      <li class="c-sidebar-nav-item" *ngIf="usuario!.includes('DEPARTAMENTO')">
        <a class="c-sidebar-nav-link" matRipple routerLink="departamento" routerLinkActive="c-active"
          [routerLinkActiveOptions]="menuSubset">
          <i class="c-sidebar-nav-icon"><mat-icon>business</mat-icon></i>
          <span class="c-sidebar-nav-text">Departamentos</span>
        </a>
      </li>
      <li class="c-sidebar-nav-item" *ngIf="usuario!.includes('CARGO')">
        <a class="c-sidebar-nav-link" matRipple routerLink="cargo" routerLinkActive="c-active"
          [routerLinkActiveOptions]="menuSubset">
          <i class="c-sidebar-nav-icon"><mat-icon>work</mat-icon></i>
          <span class="c-sidebar-nav-text">Cargos</span>
        </a>
      </li>
      <li class="c-sidebar-nav-item" *ngIf="usuario!.includes('COLABORADOR')">
        <a class="c-sidebar-nav-link" matRipple routerLink="colaborador" routerLinkActive="c-active"
          [routerLinkActiveOptions]="menuSubset">
          <i class="c-sidebar-nav-icon"><mat-icon>badge</mat-icon></i>
          <span class="c-sidebar-nav-text">Colaboradores</span>
        </a>
      </li>
    </ul>
  </li>

  <!-- Tickets -->
  <li class="c-sidebar-nav-dropdown" [class.c-show]="menusAbertos['tickets']"
    *ngIf="usuario!.includes('TICKET')">
    <a class="c-sidebar-nav-dropdown-toggle" (click)="alternarMenu('tickets')">
      <i class="c-sidebar-nav-icon"><mat-icon>support_agent</mat-icon></i>
      <span class="c-sidebar-nav-text">Tickets</span>
    </a>
    <ul class="c-sidebar-nav-dropdown-items">
      <li class="c-sidebar-nav-item">
        <a class="c-sidebar-nav-link" matRipple routerLink="ticket/consulta" routerLinkActive="c-active"
          [routerLinkActiveOptions]="menuSubset">
          <i class="c-sidebar-nav-icon"><mat-icon>confirmation_number</mat-icon></i>
          <span class="c-sidebar-nav-text">Ticket</span>
        </a>
      </li>
      <li class="c-sidebar-nav-item">
        <a class="c-sidebar-nav-link" matRipple routerLink="ticket/kanban" routerLinkActive="c-active"
          [routerLinkActiveOptions]="menuSubset">
          <i class="c-sidebar-nav-icon"><mat-icon>view_column</mat-icon></i>
          <span class="c-sidebar-nav-text">Kanban</span>
        </a>
      </li>
    </ul>
  </li>

  <!-- Relatórios -->
  <li class="c-sidebar-nav-dropdown" [class.c-show]="menusAbertos['relatorios']"
    *ngIf="usuario!.includes('RELATORIO_CONTA_RECEBER') || usuario!.includes('RELATORIO_CONTA_PAGAR') || usuario!.includes('RELATORIO_TICKET') || usuario!.includes('RELATORIO_CLIENTE')">
    <a class="c-sidebar-nav-dropdown-toggle" (click)="alternarMenu('relatorios')">
      <i class="c-sidebar-nav-icon"><mat-icon>assessment</mat-icon></i>
      <span class="c-sidebar-nav-text">Relatórios</span>
    </a>
    <ul class="c-sidebar-nav-dropdown-items">
      <li class="c-sidebar-nav-item" *ngIf="usuario!.includes('RELATORIO_CONTA_RECEBER')">
        <a class="c-sidebar-nav-link" matRipple routerLink="relatorios/contas-receber" routerLinkActive="c-active"
          [routerLinkActiveOptions]="menuSubset">
          <i class="c-sidebar-nav-icon"><mat-icon>request_quote</mat-icon></i>
          <span class="c-sidebar-nav-text">Contas a Receber</span>
        </a>
      </li>
      <li class="c-sidebar-nav-item" *ngIf="usuario!.includes('RELATORIO_CONTA_PAGAR')">
        <a class="c-sidebar-nav-link" matRipple routerLink="relatorios/contas-pagar" routerLinkActive="c-active"
          [routerLinkActiveOptions]="menuSubset">
          <i class="c-sidebar-nav-icon"><mat-icon>price_check</mat-icon></i>
          <span class="c-sidebar-nav-text">Contas a Pagar</span>
        </a>
      </li>
      <li class="c-sidebar-nav-item" *ngIf="usuario!.includes('RELATORIO_TICKET')">
        <a class="c-sidebar-nav-link" matRipple routerLink="relatorios/tickets" routerLinkActive="c-active"
          [routerLinkActiveOptions]="menuSubset">
          <i class="c-sidebar-nav-icon"><mat-icon>confirmation_number</mat-icon></i>
          <span class="c-sidebar-nav-text">Tickets</span>
        </a>
      </li>
      <li class="c-sidebar-nav-item" *ngIf="usuario!.includes('RELATORIO_CLIENTE')">
        <a class="c-sidebar-nav-link" matRipple routerLink="relatorios/clientes" routerLinkActive="c-active"
          [routerLinkActiveOptions]="menuSubset">
          <i class="c-sidebar-nav-icon"><mat-icon>groups_2</mat-icon></i>
          <span class="c-sidebar-nav-text">Clientes</span>
        </a>
      </li>
    </ul>
  </li>

  <!-- Banner -->
  <li class="c-sidebar-nav-item" *ngIf="usuario!.includes('BANNER')">
    <a class="c-sidebar-nav-link" matRipple routerLink="banner" routerLinkActive="c-active"
      [routerLinkActiveOptions]="menuSubset">
      <i class="c-sidebar-nav-icon"><mat-icon>campaign</mat-icon></i>
      <span class="c-sidebar-nav-text">Banner WowGo</span>
    </a>
  </li>

  <!-- Configurações / Acesso -->
  <li class="c-sidebar-nav-dropdown" [class.c-show]="menusAbertos['acesso']">
    <a class="c-sidebar-nav-dropdown-toggle" (click)="alternarMenu('acesso')">
      <i class="c-sidebar-nav-icon"><mat-icon>settings</mat-icon></i>
      <span class="c-sidebar-nav-text">Configurações</span>
    </a>
    <ul class="c-sidebar-nav-dropdown-items">
      <li class="c-sidebar-nav-item" *ngIf="usuario!.includes('PERFIL')">
        <a class="c-sidebar-nav-link" matRipple routerLink="perfil" routerLinkActive="c-active"
          [routerLinkActiveOptions]="menuSubset">
          <i class="c-sidebar-nav-icon"><mat-icon>security</mat-icon></i>
          <span class="c-sidebar-nav-text">Perfil</span>
        </a>
      </li>
      <li class="c-sidebar-nav-item">
        <a class="c-sidebar-nav-link" matRipple routerLink="usuario" routerLinkActive="c-active"
          [routerLinkActiveOptions]="menuSubset">
          <i class="c-sidebar-nav-icon"><mat-icon>person</mat-icon></i>
          <span class="c-sidebar-nav-text">Usuários</span>
        </a>
      </li>
    </ul>
  </li>

  <ng-content></ng-content>

</ul>
